import { render, staticRenderFns } from "./AgendaNuovaPrestazioneModalComponent.vue?vue&type=template&id=b05c1718"
import script from "./AgendaNuovaPrestazioneModalComponent.vue?vue&type=script&lang=js"
export * from "./AgendaNuovaPrestazioneModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports